import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Bell, Sparkles } from 'lucide-react';
import { Card } from '../components/ui/card';
import { API } from '../context/AuthContext';
import axios from 'axios';

const tagColors = {
  welcome: 'bg-emerald-100 text-emerald-700',
  navodaya: 'bg-orange-100 text-orange-700',
  board: 'bg-blue-100 text-blue-700',
  info: 'bg-gray-100 text-gray-700',
};

function formatDate(d) {
  const date = new Date(d);
  const diff = (Date.now() - date.getTime()) / 1000;
  if (diff < 60) return 'ଏବେ';
  if (diff < 3600) return `${Math.floor(diff / 60)} ମିନଟ`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ଘଣ୍ଟା`;
  return `${Math.floor(diff / 86400)} ଦିନ`;
}

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/notifications`, { withCredentials: true })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-4 pt-4 space-y-4">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-emerald-600 font-medium">
        <ArrowLeft size={16} /> ମୁଖ୍ୟ ପେଜ କୁ ଫେରନ୍ତୁ
      </Link>

      <div className="rounded-3xl p-5 text-white shadow-lg" style={{ background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 60%, #0e7490 100%)' }}>
        <Bell size={26} />
        <h1 className="text-xl font-extrabold mt-2">ସୂଚନା · Notifications</h1>
        <p className="text-xs text-white/90 mt-1">ନୂଆ update, ପରୀକ୍ଷା alert ଓ event</p>
      </div>

      {loading && <Card className="rounded-2xl p-6 border-gray-200 text-center text-sm text-gray-500">Loading...</Card>}

      {!loading && items.length === 0 && (
        <Card className="rounded-2xl p-8 border-gray-200 text-center">
          <Bell size={40} className="mx-auto text-gray-300 mb-2" />
          <div className="text-sm text-gray-600">କୌଣସି ସୂଚନା ନାହିଁ</div>
        </Card>
      )}

      <div className="space-y-2">
        {items.map((n) => (
          <Card key={n.id || n.title} className="rounded-2xl p-4 border-gray-200 hover:border-cyan-300 transition-colors">
            <div className="flex items-start gap-3">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${tagColors[n.tag] || tagColors.info}`}>
                <Sparkles size={17} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <div className="font-bold text-sm text-gray-900">{n.title}</div>
                  <span className="text-[10px] text-gray-500 shrink-0">{formatDate(n.created_at)}</span>
                </div>
                <p className="text-xs text-gray-600 mt-0.5 leading-relaxed">{n.body}</p>
                <span className={`inline-block mt-1.5 text-[9px] font-bold px-1.5 py-0.5 rounded uppercase ${tagColors[n.tag] || tagColors.info}`}>{n.tag}</span>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
